import getCustomIcon from '../../../icons/custom/getCustomIcon';
import * as kompisIcons from '@inter-ikea-kompis/icons';
import { ITheme } from '@inter-ikea-kompis/types';
import { ButtonTypeEnum } from '@inter-ikea-kompis/component-button';
import { IconButtonSizeEnum } from '@inter-ikea-kompis/component-icon-button';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export interface IconProps {
  iconName: string;
  type?: ButtonTypeEnum;
  size?: IconButtonSizeEnum;
  onClick?: (customEvent: CustomEvent) => any;
  theme?: ITheme;
  className?: any;
  label?: string;
  ariaLabel?: string;
  invertedColors?: boolean;
  flipIconRtl?: boolean;
}

/**
 * Get kompis icon
 * @param iconName
 * @param theme
 * @returns {string|*}
 */
export const getKompisIconData = (iconName: string, theme?: ITheme) => {
  const errorString = `The icon with name ${iconName} is not found amongst our custom icons or kompis icons.`;
  const svgAsString = getCustomIcon(iconName)
    ? getCustomIcon(iconName)
    : // @ts-ignore
      kompisIcons[iconName];

  if (!svgAsString) throw new Error(errorString);

  return {
    icon: svgAsString,
    theme: SkapaTheme,
  };
};
